import {
  ALPHA_NUMERIC,
  OnboardConstants,
  PlaceHolderText,
  StaffListConstants,
} from "../../constants/constants";
import Button from "./cta/Button";
import Input from "./cta/Input";
import {
  staffVerificationCancelButton,
  staffVerificationverifiedButton,
  staffVerificationverifyButton,
} from "./styles/CommonStyles";
import { TextFeild } from "./TextFeild";

export const PANVerificationDetail = ({
  userInfo,
  handleChange,
  isDetailPresent,
  handleVerifyButtonChange,
  verifyTitle,
  handelCancelButton,
  showVerifyButton,
}: any) => {
  return (
    <>
      {isDetailPresent ? (
        <div className="pl-6 md:pl-8 pt-10 grid md:grid-rows-1 md:grid-flow-col pr-4 md:pr-8 gap-5 md:pr-[292px]">
          <TextFeild
            textFeildName={StaffListConstants.PANNumber}
            placeholder={userInfo?.bankDetails?.panNumber ?? ""}
          />
        </div>
      ) : (
        <div className="flex gap-4 md:gap-8 px-6 md:px-0 md:pl-8">
          <div className="w-full md:w-1/2 relative">
            <Input
              type="text"
              name="panNumber"
              value={userInfo?.bankDetails?.panNumber ?? ""}
              placeholder={PlaceHolderText.panNumber}
              handleOnChange={handleChange}
              label="PAN*"
              regexCode={ALPHA_NUMERIC}
              //   borderColor={
              //     bankDetailFormError &&
              //     bankDetailFormError?.panNumber?.length !== 0
              //       ? "border-redColor"
              //       : "border-sideMenuHelpBox"
              //   }
            />
          </div>
        </div>
      )}
      <div className="px-1 md:pl-8 flex justify-center md:justify-start items-center md:items-start">
        <div className="flex">
          {!userInfo?.ekycStatus?.pan && (
            <div className="mb-6">
              <Button
                handleClick={handelCancelButton}
                buttonText={StaffListConstants.Cancel}
                className={staffVerificationCancelButton}
              />

              <Button
                handleClick={
                  showVerifyButton
                    ? () => handleVerifyButtonChange(verifyTitle)
                    : () => {}
                }
                buttonText={
                  !userInfo?.ekycStatus?.pan
                    ? OnboardConstants.verify
                    : OnboardConstants.verified
                }
                className={
                  !userInfo?.ekycStatus?.pan
                    ? staffVerificationverifyButton
                    : staffVerificationverifiedButton
                }
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};
